{
  "$schema": "http://json-schema.org/draft-07/schema",
  "type": "object",
  "title": "Consent to Act",
  "description": "Variables about a director and their appointment.",
  "properties": {
    "authorized_signatory": {
      "$ref": "#/definitions/authorized_signatory"
    },
    "company": { "$ref": "#/definitions/company" },
    "stakeholder_relationship": {
      "$ref": "#/definitions/stakeholder_relationship"
    }
  },
  "additionalProperties": false
}
